<template>
  <div class="exam-content-rts">
    <div class="title">
      Listen to and read a description of a situation. 
      You wil have 10 seconds to think about your answer. 
      Then you willhear a beep. You wilhave 40 seconds to answer the question, Please answer as completely as you can.
    </div>
    <div class="answer-detail">
      <p>{{ this.detail.content_text }}</p>
    </div>
    <div class="record-wrap">
      <div>
        <div class="audio">
          <Audio :url="detail.audio.url" :onInit="handleAudioInit" />
        </div>
      </div>
    </div>
    <div class="ques-answer">
      <div>
        <label>答题记录:</label>
        <span><AudioMini :url="examInfo.user_answer"/></span>
      </div>
    </div>
  </div>
</template>

<script>
import AudioMini from '@/components/Audio/Audio.vue'
import Audio from '../../components/audio'
import api from '@/api/exam'

export default {
  components: {
    Audio,
    AudioMini
  },
  props: {
    detail: {
      type: Object,
      default: () => ({})
    },
    examInfo: {
      type: Object,
      default: () => ({})
    },
    info: {
      type: Object,
      default: () => ({})
    }
  },
  data() {
    return {
      recoredWaitTime: 0
    }
  },
  methods: {
    submit() {
      if (this.$refs.record && this.$refs.record.stop) {
        this.$refs.record.stop()
        return true
      }
    },

    handleAudioInit(audioTime, waitTime) {
      this.recoredWaitTime = Math.round(audioTime + waitTime + 30)
    },
    async handleUplaod(url) {
      await api.submit({
        my_exam_id: this.examInfo.my_exam_id,
        qid: this.itemData.gre_try_id,
        oss_url: url
      })
      this.onFinish()
    }
  }
}
</script>

<style scoped lang="scss">
.exam-content-rts {
  color: #1f1f40;
  .title {
    margin-top: 24px;
    font-size: 16px;
    font-weight: bold;
  }
  .record-wrap {
    margin-top: 24px;
    display: flex;
    justify-content: center;
    align-items: center;
    img {
      margin-right: 65px;
      width: 260px;
    }
    .audio {
      margin-top: 24px;
    }
  }
  .answer-detail {
    margin: 20px auto;
    padding: 12px 16px;
    width: 777px;
    min-height: 44px;
    background-color: #f6f6f6;
    border-radius: 10px;
    font-size: 18px;
    font-weight: 400;
    line-height: 22px;
    color: #1f1f40;
    .word {
      display: inline-block;
      margin-right: 3px;
    }
  }
  .record {
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }
  .audio {
    margin-top: 24px;
    display: flex;
    justify-content: center;
  }
  .ques-answer {
    padding: 16px;
    margin-top: 30px;
    background-color: #f6f6f6;
    border-radius: 10px;
    > div {
      display: flex;
      align-items: center;
      margin-top: 8px;
      &:first-child {
        margin-top: 0;
      }
      > label {
        display: flex;
        align-items: center;
        justify-content: center;
        min-width: 68px;
        padding: 0 10px;
        height: 24px;
        background-color: #dcdcdc;
        border-radius: 20px;
        font-size: 16px;
        color: #9c9c9c;
      }
      > span {
        margin-left: 16px;
        color: #1f1f40;
        font-size: 18px;
        flex: 1;
      }
    }
  }
}
</style>
